import {Suspense} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit} from './modules/auth'
import {ThemeModeProvider} from '../_metronic/partials'

import { AgentProvider } from './modules/apps/call/AgentContext'
import { useMultiTab } from './hooks/useMultiTab'

import './styles.css'
// 1. TOAST CONTAINER //
import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const App = () => {
  const { isMaster } = useMultiTab();

  if (!isMaster) {
    return (
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', 
        height: '100vh', width: '100vw', backgroundColor: '#f3f4f6', color: '#374151', padding: '20px', textAlign: 'center'
      }}>
        <i className='bi bi-exclamation-triangle text-warning' style={{ fontSize: '4rem', marginBottom: '20px' }}></i>
        <h1 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '10px' }}>
          Aplikasi Sudah Terbuka di Tab Lain
        </h1>
        <p style={{ fontSize: '1.1rem', maxWidth: '500px', lineHeight: '1.5' }}>
          Untuk menghindari bentrok panggilan dan error pada sistem, aplikasi hanya dapat dijalankan di satu tab. 
          Harap gunakan tab utama Anda, atau tutup tab ini.
        </p>
      </div>
    )
  }

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <ThemeModeProvider>
            <AuthInit>
              <AgentProvider>
                <Outlet />
                <MasterInit />

              {/* 2. TOAST CONTAINER BELOW */}
              <ToastContainer
                position='top-right'
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme='light'
              />
              </AgentProvider>
            </AuthInit>
          </ThemeModeProvider>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export {App}
